export default __webpack_public_path__ + "static/media/polygon-icon.d3886969.svg";